<template>
  <v-sheet elevation="2" class="rounded white d-flex flex-column ">
    <v-tabs v-model="activeTab" slider-size="4" slider-color="blue">
      <v-tab active-class="grey--text text--darken-4">{{
        $t('ai_features.organization_ai_settings.token_management')
      }}</v-tab>

      <v-tab v-if="!isReadOnly" active-class="grey--text text--darken-4">{{
        $t('ai_features.organization_ai_settings.organization_ai_managers')
      }}</v-tab>

      <v-tab v-if="!isReadOnly" active-class="grey--text text--darken-4">{{
        $t('ai_features.organization_ai_settings.llm_settings')
      }}</v-tab>
    </v-tabs>

    <v-tabs-items v-model="activeTab">
      <v-tab-item class="pa-4">
        <TokenManagement
          :isReadOnly="isReadOnly"
          :organization="organization"
        />
      </v-tab-item>

      <v-tab-item v-if="!isReadOnly" class="pa-4">
        <OrganizationAIManagers :organization="organization" />
      </v-tab-item>

      <v-tab-item v-if="!isReadOnly" class="pa-4">
        <LLMSettings :organization="organization" />
      </v-tab-item>
    </v-tabs-items>
  </v-sheet>
</template>
<script>
import { mapGetters } from 'vuex'
import access from '@/lib/access.js'

import OrganizationAIManagers from './AdminAISettings/OrganizationAIManagers.vue'
import TokenManagement from './AdminAISettings/TokenManagement.vue'
import LLMSettings from './AdminAISettings/LLMSettings.vue'

export default {
  name: 'AdminAISettings',

  components: {
    TokenManagement,
    OrganizationAIManagers,
    LLMSettings,
  },

  props: {
    organization: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      activeTab: 0,
    }
  },

  computed: {
    ...mapGetters(['account']),

    isReadOnly() {
      return !access.isAIAdmin(this.account)
    },
  },
}
</script>
